// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage-module__container--UGUt9","title":"ErrorPage-module__title--JdR2W","text":"ErrorPage-module__text--IxXL_"};